module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-Center__And__Page_Break"
  }, [_c('span', [_vm._v("For Betty, my stepmother, because without her encouragement and her Harlequin Romances, I wouldn’t have written this story.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticClass: "C_FirstWords"
  }, [_vm._v("TO")]), _vm._v(" Desi, because she had to deal with me editing this novel while my personal life wasn’t the best. She was patient with the missed deadlines and long periods of silence while I dealt with Real Life Issues.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("For Lynn and Poppy, when they announced the Dreamspun Desires line, jumped on my pitch with wonderful enthusiasm.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And Elizabeth for starting this wonderful company; I’ve had a lovely time here, because she makes everyone feel like family.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lastly, Ed for his beta reading and support; all the mistakes are mine and not his. Tamazusa, Mason, and Phoenix gave up a lot of lap time and cuddles while I typed and edited my work—the poor kitties. Such are the sacrifices my kitties make for the written word.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34cb2de7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0004.vue
// module id = 66
// module chunks = 0